import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {FIELD_LIST_INPUT_MBE, FIELD_NAME_INPUT_MBE} from "../../../utils/input-field-list-static-page";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import {cloneDeep} from "lodash";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import React, {useEffect} from "react";
import FormItemComponent from "../../../components/static-page/form-item.component";
import Item from "../../avoskin-trail-run/mind-body-environment/item";
import {
    setAvoskinTrailRunErrorMessage,
    setAvoskinTrailRunMindBodyEnvironmentDetail
} from "../../../reducers/avoksin-trail-run.reducer";

const MindBodyEnvironment = () => {
    const dispatch = useDispatch()
    const {mindBodyEnvironmentDetail} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getMBE} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_MIND_BODY_ENVIRONMENT)
    const {fetching: updateMBE, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_MIND_BODY_ENVIRONMENT)
    const itemList = [...mindBodyEnvironmentDetail.banners]
    let fieldList = FIELD_LIST_INPUT_MBE
    let showMBE = {
        label: 'Mind Body Environment',
        key: 'show_mbe',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunMindBodyEnvironmentDetail({[key]: value}))
    }

    const addItemHandler = () => {
        if (mindBodyEnvironmentDetail.banners?.length < 3) {
            itemList.push({
                id: randomCode(5, 1, 'banner').toString(),
                desktop_url: null,
                mobile_url: null,
                title: null
            })
            dispatch(setAvoskinTrailRunMindBodyEnvironmentDetail({banners: itemList}))
        } else {
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('warning'))
            dispatch(setToolsAlertMessage('Image tidak boleh lebih dari 3'))
        }
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(mindBodyEnvironmentDetail.banners)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataMBE = {...mindBodyEnvironmentDetail, banners: dataItemList}
        updateMBE(dataMBE).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Mind Body Environment Updated'))
            dispatch(setAvoskinTrailRunMindBodyEnvironmentDetail({...response?.data, delete_ids: []}))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_INPUT_MBE)))
        })
    }

    useEffect(() => {
        getMBE().then(response => {
            if (response?.data?.banners?.length > 0) {
                dispatch(setAvoskinTrailRunMindBodyEnvironmentDetail({...response?.data, delete_ids: []}))
            } else {
                const data = response?.data
                delete data?.banners
                dispatch(setAvoskinTrailRunMindBodyEnvironmentDetail({...data, delete_ids: []}))
            }
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={mindBodyEnvironmentDetail}
            switchToggleField={showMBE}
            itemList={itemList}
            content={(index) => <Item fieldList={fieldList} index={index}/>}
            onChange={onChange}
            setDataList={setAvoskinTrailRunMindBodyEnvironmentDetail}
            deleteList={mindBodyEnvironmentDetail?.delete_ids}
            objectName={'banners'}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            isLoading={isLoading}
        />
    )
}

export default MindBodyEnvironment
